module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('svg', {
    staticClass: "svg-content",
    attrs: {
      "viewBox": _vm.viewBox,
      "preserveAspectRatio": "xMinYMin meet"
    }
  }, [_c('g', [_vm._l((_vm.holes), function(hole, index) {
    return [_c('harmap-col', {
      key: hole,
      attrs: {
        "x": _vm.xColCoord(index),
        "y": _vm.yColCoord(),
        "hole-number": index,
        "max-blow": _vm.maxblow,
        "max-draw": _vm.maxdraw,
        "hole": hole
      }
    })]
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c9ac600e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HarmapGrid.vue
// module id = 101
// module chunks = 1